module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fmh"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I want to thank my agent, Jacques de Spoelberch, for his continual guidance, and my editor, Daniela Rapp, for her enduring patience.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I also want to thank Jenny Hancey, Mary Anne Mier, Julia Nichols, and Jenny Ramsey for all their help.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Last, I want to thank my wife, Marion, and daughter, Jin, for allowing me to be distracted temporarily while I wrote this book.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c150588c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 69
// module chunks = 0